import React, { useState } from "react";
import { client } from "@/lib/api";
import { toast } from "sonner";

// WW-208 / WW-211 · preview lists every change and every skip; apply needs the count typed back.
const box = { padding: 16, borderRadius: 14, border: "1px solid var(--ww-line)", background: "var(--ww-surface)" };
const btn = (bg, color) => ({ padding: "10px 16px", borderRadius: 10, border: `1px solid ${bg}`, background: bg, color,
  fontFamily: "Poppins", fontWeight: 700, fontSize: 13, textTransform: "lowercase", cursor: "pointer", minHeight: 40 });

export const PreviewApplyPanel = ({ id, title, note, path, verb, renderRow, extra }) => {
  const [preview, setPreview] = useState(null);
  const [typed, setTyped] = useState("");
  const [busy, setBusy] = useState(false);
  const load = async () => {
    setBusy(true);
    try { setPreview((await client.get(`${path}/preview`)).data); setTyped(""); }
    catch { toast.error("preview failed"); } finally { setBusy(false); }
  };
  const apply = async () => {
    setBusy(true);
    try {
      const r = await client.post(`${path}/apply`, { confirm_count: Number(typed) });
      toast.success(r.data.noop ? "nothing to change" : `changed ${r.data.changed} rows`);
      await load();
    } catch (e) { toast.error(e?.response?.data?.detail?.message || "apply failed"); } finally { setBusy(false); }
  };
  const n = preview?.would_change ?? 0;
  const off = busy || !n || Number(typed) !== n;
  return (
    <div data-testid={`ops-card-${id}`} style={box}>
      <h2 style={{ fontFamily: "Poppins", fontWeight: 800, fontSize: 18 }}>{title}</h2>
      <p style={{ fontFamily: "Arial", fontSize: 13, color: "var(--ww-text-muted)", marginTop: 4 }}>{note}</p>
      <button data-testid={`${id}-preview`} className="mt-3" onClick={load} disabled={busy} style={{ ...btn("transparent", "var(--ww-text)"), border: "1px solid var(--ww-line-strong)" }}>preview</button>
      {preview && (
        <div className="mt-3" style={{ fontFamily: "Arial", fontSize: 13 }}>
          <p data-testid={`${id}-summary`}>would change <b data-testid={`${id}-count`}>{n}</b> · skips <b>{preview.skipped.length}</b></p>
          {extra && extra(preview) && <p data-testid={`${id}-explain`} style={{ color: "var(--ww-text-muted)" }}>{extra(preview)}</p>}
          <ul data-testid={`${id}-list`} className="mt-2" style={{ maxHeight: 220, overflow: "auto" }}>
            {preview.rows.map((r) => <li key={`${r.collection || ""}${r.id}`} data-testid={`${id}-row-${r.id}`}>{renderRow(r)}</li>)}
          </ul>
          <p className="mt-2" style={{ color: "var(--ww-text-muted)" }}>skipped</p>
          <ul data-testid={`${id}-skipped`} style={{ maxHeight: 160, overflow: "auto", color: "var(--ww-text-muted)" }}>
            {preview.skipped.map((r, i) => <li key={`${r.id}-${i}`}>{r.title || r.id} · {r.reason}</li>)}
          </ul>
          <div className="mt-3 flex flex-wrap items-center gap-2">
            <input data-testid={`${id}-confirm-input`} value={typed} onChange={(e) => setTyped(e.target.value.replace(/\D/g, ""))}
              placeholder={`type ${n} to confirm`} style={{ height: 40, padding: "0 10px", borderRadius: 10, border: "1px solid var(--ww-line-strong)", background: "transparent", color: "var(--ww-text)" }} />
            <button data-testid={`${id}-apply`} onClick={apply} disabled={off} style={{ ...btn("#D64545", "#FFFFFF"), opacity: off ? 0.5 : 1 }}>
              {verb} {n}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
